module.exports = __webpack_public_path__ + "img/pho_simpas.75de0aa2.jpg";